// extracted by mini-css-extract-plugin
module.exports = {"secondaryTitle":"TerritoryClassInfo_secondaryTitle__1bj2N","sectionTitleBoxInfo":"TerritoryClassInfo_sectionTitleBoxInfo__1K9r3"};